// extracted by mini-css-extract-plugin
export default {"videoPlayer":"styles_videoPlayer__qEsdW"};